export const GET_TIMEFRAME_VEHICLE_LOGS = "V3_GET_TIMEFRAME_VEHICLE_LOGS"
export const GET_TIMEFRAME_VEHICLE_DERIVATIVE_LOGS = 'V3GET_TIMEFRAME_VEHICLE_DERIVATIVE_LOGS'
export const GET_TIMEFRAME_VEHICLE_GEO_STATE_LOGS = 'V3GET_TIMEFRAME_VEHICLE_GEO_STATE_LOGS'
export const GET_TIMEFRAME_VEHICLE_EVENT_LOGS = 'V3GET_TIMEFRAME_VEHICLE_EVENT_LOGS'
export const CLEAR_TIMEFRAME_VEHICLE_EVENT_LOGS = 'V3_CLEAR_TIMEFRAME_VEHICLE_EVENT_LOGS'
export const GET_TIMEFRAME_VEHICLE_ECU_LOGS = 'V3GET_TIMEFRAME_VEHICLE_ECU_LOGS'
export const SET_SELECTED_VEHICLE_FOR_VEHICLE_LOG = "V3_SET_SELECTED_VEHICLE_FOR_VEHICLE_LOG"
export const UNSET_SELECTED_VEHICLE_FOR_VEHICLE_LOG = "V3_UNSET_SELECTED_VEHICLE_FOR_VEHICLE_LOG"
export const SET_SELECTED_VEHICLE_LOG_TIME = "V3_SET_SELECTED_VEHICLE_LOG_TIME"
export const CLEAR_VEHICLE_EVENT_LOG = "V3_CLEAR_VEHICLE_EVENT_LOG"
export const SET_SELECTED_EVENT_LOG_VID = 'V3_SET_SELECTED_EVENT_LOG_VID'
export const UNSET_SELECTED_EVENT_LOG_VID = 'V3_UNSET_SELECTED_EVENT_LOG_VID'
export const UPDATE_VEHICLE_EVENT_LOG = 'V3_UPDATE_VEHICLE_EVENT_LOG'